export type SessionDataChangedEventPayload = string[];

export const SessionDataChangedEventType = 'aboveCloud_sessionDataChangedEvent';

export class SessionDataChangedEvent extends CustomEvent<SessionDataChangedEventPayload> {
  constructor(payload: SessionDataChangedEventPayload) {
    super(SessionDataChangedEventType, { detail: payload });
  }
}
